export const SupportIcon: React.FC<{ color?: string }> = ({
  color = "#bfa073",
}) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M3 14C3 9.02944 7.02944 5 12 5C16.9706 5 21 9.02944 21 14"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M21 14C21 15.1046 20.1046 16 19 16H18C16.8954 16 16 15.1046 16 14V12C16 10.8954 16.8954 10 18 10H21V14Z"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M3 14C3 15.1046 3.89543 16 5 16H6C7.10457 16 8 15.1046 8 14V12C8 10.8954 7.10457 10 6 10H3V14Z"
      fill="none"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M19 16C19 18.2091 17.2091 20 15 20H12"
      stroke={color}
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);
